import product_company_config from "@/components/ProductCompany/config";
import reference_config from "@/components/Reference/config";
import stored_file_config from "@/components/StoredFile/config";
import related_product_config from "@/components/RelatedProduct/config";

// Prix journalier actif d'une tranche de la grille ESM, celle du formulaire produit
// (les prix Axiloc historiques, sans grille, restent ceux des contrats d'avant la MEP).
export const esmPrice = (item, range) => {
  const price = item && item.prices && item.prices.find((price) => price.price_range == range && price.grid_code == "esm")
  return price ? price.price_value : null
}

export default {
  storeNamespace: 'product',
  // ?movement=<id> : modale « Enregistrer un mouvement de stock » ouverte (ProductList)
  urlKeepParams: ['movement'],
  authFeature: 'product',
  listRouteName: "ProductList",
  editRouteName: "ProductEdit",
  detailRouteName: "ProductDetail",
  hideActionDeleteButton: true,
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'ProductForm',
  csvExportFilenamePrefix: 'produits',
  titleField: 'name',
  // Un produit qu'on arrête sort du catalogue : exiger d'abord qu'on complète sa fiche (photo,
  // fournisseur, marque…) empêcherait justement de retirer les fiches incomplètes. Seuls le
  // nom, la nature et le statut restent exigés (`alwaysRequired`) — l'API ne s'en passe pas.
  requiredWaiver: (form, $store) => {
    const stopped = $store.getters["status/getItem"]("product_stopped");
    return !!form.id && !!stopped && form.status_id == stopped.id;
  },
  valideFormFunction: form => form.parents && form.parents.filter(group => group.child_product_type == 'product_variation').length > 1 ? "Un produit ne peut pas être une déclinaison de plusieurs produits parents" : true,
  fields: [
    {
      name: 'type',
      label: "type",
      type: 'select',
      inList: true,
      extendedFilter: true,
      sortable: true,
    },
    {
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      alwaysRequired: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'parent_product_type',
      label: "Type de produit parent",
      type: 'select',
      inForm: true,
      required: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$store.getters['product/getParentType'](value).text : null
    },
    {
      name: 'parents',
      label: "Définir comme produit enfant de",
      type: 'group_repeater',
      inForm: true,
      inDetail: true,
      fields: [
        {
          name: 'child_product_type',
          label: "Type de produit enfant",
          type: 'select',
          inForm: true,
        },
        {
          name: 'product_parent_id',
          label: "Produit parent",
          type: 'select',
          inForm: true,
          options: ($store, form, field_group) => $store.getters["product/getAllByParentType"]($store.getters["product/getParentTypeByChildType"](field_group.child_product_type)).selectOptions("id", "name"),
        },
        {
          name: 'quantity',
          label: "Quantité",
          type: 'number',
          inForm: true,
          inFormCondition: (form, field_group) => field_group.child_product_type == 'product_in_lot',
        }
      ]
    },
    {
      name: 'type',
      label: "type",
      type: 'select',
      inForm: true,
      required: true,
      alwaysRequired: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? (context.$store.getters['product/getType'](value) ? context.$store.getters['product/getType'](value).text : value) : null,
      options: ($store, form) => form && (form.parent_product_type || (form.parents && form.parents.length)) ? [$store.getters["product/getType"]('selling')] : $store.getters["product/getTypes"]
    },
    {
      // Pour une location pour compte, la famille remonte juste sous le type : c'est elle
      // qui commande les attributs proposés en dessous, elle doit donc se choisir d'abord.
      // Les autres natures gardent la famille à sa place habituelle, plus bas.
      name: 'equipment_group_id',
      label: "Famille",
      type: 'chosen',
      inForm: true,
      required: true,
      inFormCondition: (form) => form.type == 'location_for_account',
    },
    {
      // SFD ESM 2.10 : tout ce qui est personnalisable l'est à l'échelle du PRODUIT, et non de
      // la famille. Le catalogue comportera vraisemblablement un produit par famille, ce qui
      // rend les deux équivalents en pratique — mais rien n'interdira deux matériels d'une
      // même famille avec des formulaires distincts.
      name: 'request_attribute_ids',
      label: "Attributs de demande",
      description: "Choisissez d'abord une famille : seuls ses attributs sont proposés, avec les valeurs qu'ils demanderont.",
      type: 'chosen',
      multiple: true,
      inForm: true,
      inDetail: true,
      inFormCondition: (form) => form.type == 'location_for_account',
      formatter: (context, value) => Array.isArray(value) && value.length
        ? value.map(id => {
            const attribute = context.$store.getters['request_attribute/getItem'](id);
            return attribute ? attribute.label : id;
          }).join(' · ')
        : null,
    },
    {
      // Certains matériels ne sont pas facturés tous les jours de la semaine : une nacelle
      // facturée le samedi mais pas le dimanche. Rien de coché = les sept jours.
      name: 'billable_days',
      label: "Jours facturables",
      type: 'chosen',
      multiple: true,
      inForm: true,
      inDetail: true,
      inFormCondition: (form) => form.type == 'location_for_account',
      formatter: (context, value) => {
        const days = Array.isArray(value) ? value : (value ? String(value).split(',') : []);
        if (!days.length || days.length === 7) {
          return 'Tous les jours';
        }
        return days
          .map(day => {
            const option = context.$store.getters['product/getBillableDaysForSelect']
              .find(item => item.value == day);
            return option ? option.text : day;
          })
          .join(' · ');
      },
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inForm: true,
      // Location pour compte : le matériel n'entre pas au parc, il n'a pas de code interne
      // propre. Le champ reste saisissable, il n'est simplement plus exigé.
      requiredCondition: (form) => form.type != 'location_for_account',
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parents || form.parents.filter(parent => parent.child_product_type == 'product_variation').length == 0,
    },
    {
      name: 'sap_activity',
      label: "Lettre d'activité (facturation SAP)",
      type: 'select',
      inForm: true,
      inDetail: true,
      options: () => [
        { value: null, text: '—' },
        { value: 'L', text: 'LIVRAISON (L)' },
        { value: 'A', text: 'PRODUIT DIVERS (A)' },
        { value: 'E', text: 'LOC EXTERNE (E)' },
        { value: 'F', text: 'SERVICES ET REPARATION (F)' },
        { value: 'P', text: 'LOC INTERNE (P)' },
        { value: 'S', text: 'STOCKAGE (S)' },
        { value: 'D', text: 'DOTATION (D)' },
      ],
      formatter: (context, value) => ({
        L: 'LIVRAISON (L)', A: 'PRODUIT DIVERS (A)', E: 'LOC EXTERNE (E)',
        F: 'SERVICES ET REPARATION (F)', P: 'LOC INTERNE (P)', S: 'STOCKAGE (S)', D: 'DOTATION (D)',
      }[value] || null),
    },
    {
      name: 'custom_bar_code',
      label: "Code barre personnalisé",
      type: 'text',
      inForm: true,
      // Sans objet pour la nature « Location pour compte » : pas de référence unique, donc pas d'étiquette.
      inFormCondition: (form) => form.type != 'location_for_account',
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      description: 'Si renseigné, le code-barre sera généré à partir de ce champ et non du Code interne'
    },
    {
      name: 'picture',
      label: "Photo principale",
      type: 'file',
      inForm: true,
      required: true,
      inDetail: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'other_pictures',
      label: "Autres photos",
      type: 'group_repeater',
      inForm: true,
      inDetail: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
      fields: [{
        name: 'file',
        label: "Fichier",
        type: 'file',
        inForm: true,

      }]
    },
    {
      name: 'other_pictures',
      label: "Autres photos",
      type: 'list',
      icone: 'folder',
      config: stored_file_config,
      fields: ['file']
    },
    {
      name: 'equipment_group_id',
      label: "Famille",
      type: 'chosen',
      inForm: true,
      required: true,
      // Remontée sous le type pour une location pour compte : ne pas l'afficher deux fois.
      inFormCondition: (form) => form.type != 'location_for_account'
        && (!form.parents || form.parents.filter(item => item.child_product_type == 'product_variation').length == 0),
    },
    {
      // Filtre seul (pas de colonne) : distingue les produits issus de l'import MCS
      // du catalogue Axiloc. Alimenté par product.from_mcs (cf. load-sql.mjs).
      name: 'from_mcs',
      label: "Origine",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      // Filtre seul (pas de colonne) : présence et origine des tarifs du produit.
      // « Sans aucun prix » couvre les deux tarifications — les tranches de location
      // (table price) ET le prix de vente HT (product.sale_price, seul tarif d'un
      // produit `selling`). Sert au suivi de l'import MCS : un produit non tarifé se
      // facture à zéro (PricingService fait `$priceByRange[$code] ?? 0`).
      name: 'pricing',
      label: "Tarification",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      // Filtre seul, pas de colonne : sert à repérer les produits dont le poids manque.
      // Le poids détermine le mode d'expédition (forfait Chronopost sous 30 kg, sinon
      // barème messagerie), un produit sans poids fausse le calcul du transport.
      name: 'weight_status',
      label: "Poids",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      // Filtre seul (pas de colonne) : produits présents dans l'entrepôt, par leurs
      // références (location) ou leurs mouvements de stock (vente) ; « Aucun entrepôt »
      // = présents dans aucun.
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
      extendedFilter: true,
    },
    {
      name: 'equipment_group',
      label: "Famille",
      type: 'select',
      inList: true,
      extendedFilter: true,
      sortable: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'stock',
      label: "Stock réel",
      type: 'number',
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true
    },
    {
      name: 'buffer_stock',
      label: "Stock virtuel",
      type: 'number',
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value, item) => value && value > 0 ? item.stock - value  : item.stock
    },
    {
      name: 'rent_count',
      label: "En location",
      type: 'number',
      inForm: false,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'maintenance_count',
      label: "En maintenance",
      type: 'number',
      inForm: false,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'lost_count',
      label: "Perdu/Volés",
      type: 'number',
      inForm: false,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'trash_count',
      label: "Au rebut",
      type: 'number',
      inForm: false,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    // L'environnement de stockage n'est plus un champ du produit : il est défini par entrepôt,
    // dans la répartition du stock de la fiche (SFD Échanges et stockage 1.1).
    {
      name: 'supplier_id',
      label: "Fournisseur",
      type: 'chosen',
      inForm: true,
      // Masqué pour la nature « Location pour compte » : le loueur se choisit demande par demande, pas au niveau du produit.
      inFormCondition: (form) => form.type != 'location_for_account' && (!form.parents || form.parents.length == 0),
      required: true,
    },
    {
      name: 'supplier',
      label: "Fournisseur",
      type: 'select',
      inDetail: true,
      detailLink: 'CompanyDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'brand',
      label: "Marque",
      type: 'text',
      inForm: true,
      required: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      // Masqué pour la nature « Location pour compte » : le produit décrit un TYPE de matériel générique, pas un modèle du parc.
      inFormCondition: (form) => form.type != 'location_for_account' && (!form.parents || form.parents.length == 0),
    },
    {
      name: 'model',
      label: "Modèle",
      type: 'text',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      // Masqué pour la nature « Location pour compte » : le produit décrit un type de matériel générique, pas un modèle du parc.
      inFormCondition: (form) => form.type != 'location_for_account' && (!form.parents || form.parents.length == 0),
    },
    {
      name: 'stock_mini',
      label: "Stock minimum",
      type: 'number',
      inForm: true,
      // Location pour compte : pas de stock, donc pas de seuil d'alerte à exiger.
      requiredCondition: (form) => form.type != 'location_for_account',
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parent_product_type
    },
    {
      name: 'calibration_periodicity',
      label: "Périodicité d'étalonnage / Contrôle obligatoire (jours)",
      type: 'number',
      inForm: true,
      // Masqué pour la nature « Location pour compte » : le matériel n'est pas maintenu par ESM.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'calibration_periodicity',
      label: "Périodicité d'étalonnage / Contrôle obligatoire",
      type: 'number',
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value + ' jours' : null
    },
    {
      name: 'product_companies',
      label: "Organismes d'étalonnage",
      type: 'group_repeater',
      draggable: true,
      inForm: true,
      // Masqué pour la nature « Location pour compte » : le matériel n'est pas maintenu par ESM.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
      inDetail: false,
      fields: [
        {
          name: 'company_id',
          label: "Entreprise",
          type: 'select',
          inForm: true,
          options: ($store) => $store.getters["company/getByTypeCode"](["PRST", "FRNI"]).selectOptions("id", "name"),
        }
      ]
    },
    {
      name: 'product_companies',
      label: "Organisme d'étalonnage",
      type: 'list',
      icone: 'id-building',
      config: product_company_config,
      inDetail: true,
      fields: ['company_name']
    },
    {
      name: 'calibration_provider',
      label: "Organisme d'étalonnage",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      detailLink: 'CompanyDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'imputation_number',
      label: "Numéro d'imputation",
      type: 'text',
      inForm: true,
      inFormCondition: (form) => form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations',
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'group_slug',
      label: "Service",
      type: 'select',
      inForm: true,
      // Location pour compte : le matériel ne passe par aucun service de préparation.
      requiredCondition: (form) => form.type != 'location_for_account',
      inList: true,
      extendedFilter: true,
      inFormCondition: (form) =>  !form.parent_product_type,
    },
    {
      name: 'group_slug',
      label: "Service",
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? context.$store.getters['renting_preparation/getGroup'](value).text : null
    },
    {
      name: 'applications',
      label: "Applications",
      type: 'textarea',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'characteristics',
      label: "Caractéristiques",
      type: 'textarea',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'security_rules',
      label: "Règles de sécurité",
      type: 'textarea',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'technical_sheet',
      label: "Fiche technique",
      type: 'file',
      inForm: true,
      inDetail: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'video',
      label: "Vidéo Youtube",
      type: 'text',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
    },
    {
      name: 'documents',
      label: "Documents téléchargeables",
      type: 'group_repeater',
      inForm: true,
      inDetail: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
      fields: [{
        name: 'file',
        label: "Fichier",
        type: 'file',
        inForm: true,
      }]
    },
    {
      name: 'documents',
      label: "Documents téléchargeables",
      type: 'list',
      icone: 'folder',
      config: stored_file_config,
      fields: ['file']
    },
    {
      name: 'comment',
      label: "Commentaire",
      type: 'textarea',
      inForm: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'status_id',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
      alwaysRequired: true,
      inFormCondition: (form) => form.id,
      inList: false,
      inDetail: false,
      inPdfExport: false,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inForm: false,
      inList: true,
      tabFilter: true,
      tabFilterDefaultValue: 'product_on_sale',
      key: 'status_slug',
      sortable: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'related_products',
      label: "Produits associés",
      type: 'group_repeater',
      inForm: true,
      inFormCondition: (form) => !form.parents || form.parents.length == 0,
      fields: [{
        name: 'id',
        label: "Produit à la vente",
        type: 'chosen',
        inForm: true,
      }]
    },
    {
      name: 'related_products',
      label: "Produits associés",
      type: 'list',
      icone: 'id-toolbox',
      config: related_product_config,
      inDetail: true,
      fields: ['name']
    },
    {
      name: 'purchase_price',
      label: "Prix d'achat unitaire HT",
      type: 'number',
      step: 0.01,
      inForm: true,
      // Masqué pour la nature « Location pour compte » : le matériel n'est pas acheté par ESM.
      inFormCondition: (form) => form.type != 'location_for_account' && (!form.parent_product_type),
      required: true,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'purchase_price',
      label: "Prix d'achat unitaire HT",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
    },
    {
      name: 'sale_price',
      label: "Prix de vente HT",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : le tarif est négocié demande par demande.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'selling' && (!form.parent_product_type || form.parent_product_type != 'product_lot')),
    },
    {
      name: 'sale_price',
      label: "Prix de vente HT",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inList: true,
      inPdfExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'sale_price',
      label: "Prix de vente HT",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
    },
    {
      name: 'sale_price_1',
      label: "Prix de vente HT (1 à 30 jours)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucune grille par tranches ne s'applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'sale_price_1',
      label: "Prix de vente HT (1 à 30 jours)",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => esmPrice(item, "range1") !== null ? parseFloat(esmPrice(item, "range1")).toFixed(2) + '€' : null,
    },
    {
      name: 'sale_price_1',
      label: "Prix de vente HT (1 à 30 jours)",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value, item) => esmPrice(item, "range1") !== null ? parseFloat(esmPrice(item, "range1")).toFixed(2) : null,
    },
    {
      name: 'sale_price_2',
      label: "Prix de vente HT (31 à 90 jours)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucune grille par tranches ne s'applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'sale_price_2',
      label: "Prix de vente HT (31 à 90 jours)",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => esmPrice(item, "range2") !== null ? parseFloat(esmPrice(item, "range2")).toFixed(2) + '€' : null,
    },
    {
      name: 'sale_price_2',
      label: "Prix de vente HT (31 à 90 jours)",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value, item) => esmPrice(item, "range2") !== null ? parseFloat(esmPrice(item, "range2")).toFixed(2) : null,
    },
    {
      name: 'sale_price_3',
      label: "Prix de vente HT (91 à 365 jours)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucune grille par tranches ne s'applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'sale_price_3',
      label: "Prix de vente HT (91 à 365 jours)",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => esmPrice(item, "range3") !== null ? parseFloat(esmPrice(item, "range3")).toFixed(2) + '€' : null,
    },
    {
      name: 'sale_price_3',
      label: "Prix de vente HT (91 à 365 jours)",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value, item) => esmPrice(item, "range3") !== null ? parseFloat(esmPrice(item, "range3")).toFixed(2) : null,
    },
    {
      name: 'sale_price_4',
      label: "Prix de vente HT (366 jours à 4 ans)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucune grille par tranches ne s'applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'sale_price_4',
      label: "Prix de vente HT (366 jours à 4 ans)",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => esmPrice(item, "range4") !== null ? parseFloat(esmPrice(item, "range4")).toFixed(2) + '€' : null,
    },
    {
      name: 'sale_price_4',
      label: "Prix de vente HT (366 jours à 4 ans)",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value, item) => esmPrice(item, "range4") !== null ? parseFloat(esmPrice(item, "range4")).toFixed(2) : null,
    },
    {
      name: 'sale_price_5',
      label: "Prix de vente HT (au-delà de 4 ans)",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucune grille par tranches ne s'applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations'),
    },
    {
      name: 'sale_price_5',
      label: "Prix de vente HT (au-delà de 4 ans)",
      type: 'number',
      step: 0.01,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value, item) => esmPrice(item, "range5") !== null ? parseFloat(esmPrice(item, "range5")).toFixed(2) + '€' : null,
    },
    {
      name: 'sale_price_5',
      label: "Prix de vente HT (au-delà de 4 ans)",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value, item) => esmPrice(item, "range5") !== null ? parseFloat(esmPrice(item, "range5")).toFixed(2) : null,
    },
    {
      name: 'total_turnover',
      label: "Montant total des ventes",
      type: 'number',
      inDetail: true,
      formatter: (context, value) => (value ? parseFloat(value).toFixed(2) : 0) + '€'
    },
    {
      name: 'total_cost',
      label: "Cout total des achats",
      type: 'number',
      inDetail: true,
      formatter: (context, value) => (value ? parseFloat(value).toFixed(2) : 0) + '€'
    },
    {
      name: 'weight',
      label: "Poids (kg)",
      type: 'number',
      step: 0.1,
      inForm: true,
      required: true,
      // Masqué pour la nature « Location pour compte » : aucun calcul de transport Chronopost ou messagerie ne s'y applique.
      inFormCondition: (form) => form.type != 'location_for_account' && (form.parent_product_type != 'product_with_variations'),
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => (value ? parseFloat(value).toFixed(1) : 0) + 'kg'
    },
    {
      name: 'weight',
      label: "Poids (kg)",
      type: 'number',
      step: 0.1,
      inCsvExport: true,
      formatter: (context, value) => (value ? parseFloat(value).toFixed(1) : 0)
    },
    {
      name: 'return_mode',
      label: "Mode de transport",
      type: 'select',
      inForm: true,
      inFormCondition: (form) => form.type && form.type == 'renting' && form.parent_product_type != 'product_with_variations',
      required: true,
    },
    {
      name: 'return_mode',
      label: "Mode de retour",
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => {
        if (!value) return null;
        const rm = context.$store.getters['product/getReturnMode'](value);
        return rm ? rm.text : value;
      }
    },
    {
      name: 'tags',
      label: "Tags",
      type: 'tags',
      inForm: true,
      inDetail: false,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'unique_references',
      label: "Références uniques",
      type: 'list',
      inDetail: true,
      icone: 'id-wrench',
      config: reference_config,
      fields: [
        'internal_code',
        'supplier',
        'brand',
        'model',
        'status',
        'current_warehouse',
      ]
    },

  ]
}



// WEBPACK FOOTER //
// ./src/components/Product/config.js